import interceptor from '@/plugins/interceptor';
const pathController = '/report'

export default {
  state: () => ({
    reports: [],
    pnt: [],
    business: [],
    adAgencySalesReport: []
  }),
  getters: {
    reports_sales: state => state.reports,
    reports_pnt: state => state.pnt,
    reports_business: state => state.business,
    reports_adAgencySalesReport: state => state.adAgencySalesReport
  },
  mutations: {
    reports_setSales(state, value) {
      state.reports = value;
    },
    reports_setPnt(state, value) {
      state.pnt = value;
    },
    reports_setBusiness(state, value) {
      state.business = value;
    },
    reports_setAdAgencySalesReport(state, value) {
      state.adAgencySalesReport = value;
    }
  },
  actions: {
    async reports_salesReport({ dispatch }, model) {
      try {
        const response = await interceptor.authenticate.post(`${process.env.VUE_APP_API_URL}${pathController}/salesReport`, model);
        // dispatch('notifications_create', {text: window.vueApp.$t('notifications.create'), title: window.vueApp.$t('left_menu.report.sales')});
        return response.data;
      } catch (error) {
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.response.data ? window.vueApp.$t(`notifications.validation.${error.response.data}`) : error.message}`, title: window.vueApp.$t('left_menu.report.sales'), error: true});
        throw new Error(error);
      }
    },
    async reports_setSales({ commit}, data) {
      commit('reports_setSales', data)
    },
    async reports_sponsorReport({ dispatch }, model) {
      try {
        const response = await interceptor.authenticate.post(`${process.env.VUE_APP_API_URL}${pathController}/sponsorReport`, model);
        return response.data;
      } catch (error) {
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.response.data ? window.vueApp.$t(`notifications.validation.${error.response.data}`) : error.message}`, title: window.vueApp.$t('left_menu.report.sales'), error: true});
        throw new Error(error);
      }
    },
    async reports_setPnt({ commit}, data) {
      commit('reports_setPnt', data)
    },
    async reports_businessReport({ dispatch }, model) {
      try {
        const response = await interceptor.authenticate.post(`${process.env.VUE_APP_API_URL}${pathController}/businessReport`, model);
        return response.data;
      } catch (error) {
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.response.data ? window.vueApp.$t(`notifications.validation.${error.response.data}`) : error.message}`, title: window.vueApp.$t('left_menu.report.business_unit_report'), error: true});
        throw new Error(error);
      }
    },
    async reports_setBusiness({ commit}, data) {
      commit('reports_setBusiness', data)
    },
    async reports_adAgencySalesReport({ dispatch }, model) {
      try {
        const response = await interceptor.authenticate.post(`${process.env.VUE_APP_API_URL}${pathController}/adAgencySalesReport`, model);
        return response.data;
      } catch (error) {
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.response.data ? window.vueApp.$t(`notifications.validation.${error.response.data}`) : error.message}`, title: window.vueApp.$t('left_menu.report.agency'), error: true});
        throw new Error(error);
      }
    },
    async reports_setAdAgencySalesReport({ commit}, data) {
      commit('reports_setAdAgencySalesReport', data)
    },
  }
}

